// This file serves as a common location for all your action constants

// auth
export const LOGIN = "LOGIN";
export const LOGIN_PENDING = "LOGIN_PENDING";
export const LOGIN_FULFILLED = "LOGIN_FULFILLED";
export const LOGIN_REJECTED = "LOGIN_REJECTED";
export const LOGOUT = "LOGOUT";
export const HANDLE_LOGIN_VERSION_ERROR = "HANDLE_LOGIN_VERSION_ERROR";
export const HANDLE_LOGIN_VERSION_ERROR_PENDING = "HANDLE_LOGIN_VERSION_ERROR_PENDING";
export const HANDLE_LOGIN_VERSION_ERROR_FULFILLED = "HANDLE_LOGIN_VERSION_ERROR_FULFILLED";
export const HANDLE_LOGIN_VERSION_ERROR_REJECTED = "HANDLE_LOGIN_VERSION_ERROR_REJECTED";
export const LOGIN_VERSION_ERROR = "LOGIN_VERSION_ERROR";
// register
export const REGISTER = "REGISTER";
export const REGISTER_PENDING = "REGISTER_PENDING";
export const REGISTER_FULFILLED = "REGISTER_FULFILLED";
export const REGISTER_REJECTED = "REGISTER_REJECTED";
export const REGISTER_CLEAR_ERROR = "REGISTER_CLEAR_ERROR";

//CHECK
export const CHECK = "CHECK";
export const CHECK_PENDING = "CHECK_PENDING";
export const CHECK_FULFILLED = "CHECK_FULFILLED";
export const CHECK_REJECTED = "CHECK_REJECTED";
export const CHECK_CLEAR_ERROR = "CHECK_CLEAR_ERROR";

//confirm
export const CONFIRM = "CONFIRM";
export const CONFIRM_PENDING = "CONFIRM_PENDING";
export const CONFIRM_FULFILLED = "CONFIRM_FULFILLED";
export const CONFIRM_REJECTED = "CONFIRM_REJECTED";

//forgot code
export const FORGOT_CODE = "FORGOT_CODE";
export const FORGOT_CODE_PENDING = "FORGOT_CODE_PENDING";
export const FORGOT_CODE_FULFILLED = "FORGOT_CODE_FULFILLED";
export const FORGOT_CODE_REJECTED = "FORGOT_CODE_REJECTED";

//resend code
export const RESEND_CODE = "RESEND_CODE";
export const RESEND_CODE_PENDING = "RESEND_CODE_PENDING";
export const RESEND_CODE_FULFILLED = "RESEND_CODE_FULFILLED";
export const RESEND_CODE_REJECTED = "RESEND_CODE_REJECTED";

//reset password
export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_PASSWORD_PENDING = "RESET_PASSWORD_PENDING";
export const RESET_PASSWORD_FULFILLED = "RESET_PASSWORD_FULFILLED";
export const RESET_PASSWORD_REJECTED = "RESET_PASSWORD_REJECTED";

//change password
export const CHANGE_PASSWORD = "CONFIRM";
export const CHANGE_PASSWORD_PENDING = "CONFIRM_PENDING";
export const CHANGE_PASSWORD_FULFILLED = "CONFIRM_FULFILLED";
export const CHANGE_PASSWORD_REJECTED = "CONFIRM_REJECTED";

//PUT MOBILE
export const PUT_MOBILE_NUMBER = "PUT_MOBILE_NUMBER";
export const PUT_MOBILE_NUMBER_PENDING = "PUT_MOBILE_NUMBER_PENDING";
export const PUT_MOBILE_NUMBER_FULFILLED = "PUT_MOBILE_NUMBER_FULFILLED";
export const PUT_MOBILE_NUMBER_REJECTED = "PUT_MOBILE_NUMBER_REJECTED";

//onboarding
export const ONBOARDING_OPEN = "ONBOARDING_OPEN";
export const ONBOARDING_CLOSE = "ONBOARDING_CLOSE";

//alert-modal
export const ALERT_MODAL_OPEN = "ALERT_MODAL_OPEN";
export const ALERT_MODAL_PREVIOUS = "ALERT_MODAL_PREVIOUS";
export const ALERT_MODAL_CLOSE = "ALERT_MODAL_CLOSE";

//success-modal
export const SUCCESS_MODAL_OPEN = "SUCCESS_MODAL_OPEN";
export const SUCCESS_MODAL_CLOSE = "SUCCESS_MODAL_CLOSE";

//categories
export const CATEGORIES = "CATEGORIES";
export const CATEGORIES_PENDING = "CATEGORIES_PENDING";
export const CATEGORIES_FULFILLED = "CATEGORIES_FULFILLED";
export const CATEGORIES_REJECTED = "CATEGORIES_REJECTED";

export const COUNTRIES = "COUNTRIES";
export const COUNTRIES_FULFILLED = "COUNTRIES_FULFILLED";
export const COUNTRIES_REJECTED = "COUNTRIES_REJECTED";
export const COUNTRIES_PENDING = "COUNTRIES_PENDING";

//user
export const USER_PROFILE_PATCH = "USER_PROFILE_PATCH";
export const USER_PROFILE_PATCH_PENDING = "USER_PROFILE_PATCH_PENDING";
export const USER_PROFILE_PATCH_FULFILLED = "USER_PROFILE_PATCH_FULFILLED";
export const USER_PROFILE_PATCH_REJECTED = "USER_PROFILE_PATCH_REJECTED";

export const USER_ME = "USER_ME";
export const USER_ME_PENDING = "USER_ME_PENDING";
export const USER_ME_FULFILLED = "USER_ME_FULFILLED";
export const USER_ME_REJECTED = "USER_ME_REJECTED";

export const USER_WALLET = "USER_WALLET";
export const USER_WALLET_PENDING = "USER_WALLET_PENDING";
export const USER_WALLET_FULFILLED = "USER_WALLET_FULFILLED";
export const USER_WALLET_REJECTED = "USER_WALLET_REJECTED";

export const USER_WALLET_POST = "USER_WALLET_POST";
export const USER_WALLET_POST_PENDING = "USER_WALLET_POST_PENDING";
export const USER_WALLET_POST_FULFILLED = "USER_WALLET_POST_FULFILLED";
export const USER_WALLET_POST_REJECTED = "USER_WALLET_POST_REJECTED";

export const USER_BALANCE = "USER_BALANCE";
export const USER_BALANCE_PENDING = "USER_BALANCE_PENDING";
export const USER_BALANCE_FULFILLED = "USER_BALANCE_FULFILLED";
export const USER_BALANCE_REJECTED = "USER_BALANCE_REJECTED";
export const USER_CONTENT_BALANCE = "USER_CONTENT_BALANCE";
export const USER_CONTENT_BOOSTS = "USER_CONTENT_BOOSTS";

export const USER_MOVEMENTS = "USER_MOVEMENTS";

export const USER_RESET = "USER_RESET";

export const USER_AVATAR_UPLOAD_FN = "USER_AVATAR_UPLOAD_FN";
export const USER_AVATAR_UPLOAD = "USER_AVATAR_UPLOAD";
export const USER_AVATAR_DELETE = "USER_AVATAR_DELETE";

export const FOLLOWED_CATEGORIES = "FOLLOWED_CATEGORIES";
export const FOLLOWED_CATEGORIES_PENDING = "FOLLOWED_CATEGORIES_PENDING";
export const FOLLOWED_CATEGORIES_FULFILLED = "FOLLOWED_CATEGORIES_FULFILLED";
export const FOLLOWED_CATEGORIES_REJECTED = "FOLLOWED_CATEGORIES__REJECTED";

export const FOLLOWED_CATEGORIES_POST = "FOLLOWED_CATEGORIES_POST";
export const FOLLOWED_CATEGORIES_POST_PENDING = "FOLLOWED_CATEGORIES_POST_PENDING";
export const FOLLOWED_CATEGORIES_POST_FULFILLED = "FOLLOWED_CATEGORIES_POST_FULFILLED";
export const FOLLOWED_CATEGORIES_POST_REJECTED = "FOLLOWED_CATEGORIES_POST_REJECTED";

export const USER_SEED_POST = "USER_SEED_POST";
export const USER_SEED_POST_PENDING = "USER_SEED_POST_PENDING";
export const USER_SEED_POST_FULFILLED = "USER_SEED_POST_FULFILLED";
export const USER_SEED_POST_REJECTED = "USER_SEED_POST_REJECTED";

export const USER_CONTENT_PURCHASED = "USER_CONTENT_PURCHASED";
export const USER_CONTENT_PURCHASED_PENDING = "USER_CONTENT_PURCHASED_PENDING";
export const USER_CONTENT_PURCHASED_FULFILLED = "USER_CONTENT_PURCHASED_FULFILLED";
export const USER_CONTENT_PURCHASED_REJECTED = "USER_CONTENT_PURCHASED_REJECTED";

export const USER_CONTENT_SEEDED = "USER_CONTENT_SEEDED";
export const USER_CONTENT_SEEDED_PENDING = "USER_CONTENT_SEEDED_PENDING";
export const USER_CONTENT_SEEDED_FULFILLED = "USER_CONTENT_SEEDED_FULFILLED";
export const USER_CONTENT_SEEDED_REJECTED = "USER_CONTENT_SEEDED_REJECTED";

export const USER_SEED_SAVE = "USER_SEED_SAVE";

export const USER_CONTENTS_ALL = "USER_CONTENTS_ALL";
export const USER_CONTENTS_ALL_PENDING = "USER_CONTENTS_ALL_PENDING";
export const USER_CONTENTS_ALL_FULFILLED = "USER_CONTENTS_ALL_FULFILLED";
export const USER_CONTENTS_ALL_REJECTED = "USER_CONTENTS_ALL_REJECTED";
export const USER_CONTENTS_TOP = "USER_CONTENTS_TOP";
export const USER_CONTENTS_PURCHASED = "USER_CONTENTS_PURCHASED";
export const USER_CONTENTS_BOOST = "USER_CONTENTS_BOOST";
export const USER_CONTENTS_BALANCE = "USER_CONTENTS_TOP";

export const USER_CONTENTS_STATUS = "USER_CONTENTS_STATUS";
export const USER_CONTENTS_STATUS_PENDING = "USER_CONTENTS_STATUS_PENDING";
export const USER_CONTENTS_STATUS_FULFILLED = "USER_CONTENTS_STATUS_FULFILLED";
export const USER_CONTENTS_STATUS_REJECTED = "USER_CONTENTS_STATUS_REJECTED";

export const USER_CONTENT_REVISION = "USER_CONTENT_REVISION";
export const USER_CONTENT_REVISION_TOP = "USER_CONTENT_REVISION_TOP";

export const USER_MY_SERIES = "USER_MY_SERIES";
export const CONTENT_SERIE_BY_ID = "CONTENT_SERIE_BY_ID";
export const SERIES_BY_IDS = "SERIES_BY_IDS";
export const USER_SERIES_GET = "USER_SERIES_GET";
export const USER_SEASONS_GET = "USER_SEASONS_GET";
export const USER_CHAPTERS_GET = "USER_CHAPTERS_GET";
export const USER_SERIE_GET = "USER_SERIE_GET";
export const USER_DELETE_SERIE = "USER_DELETE_SERIE";
export const SERIES_BY_IDS_PENDING = "SERIES_BY_IDS_PENDING";
export const SERIES_BY_IDS_FULFILLED = "SERIES_BY_IDS_FULFILLED";
export const SERIES_BY_IDS_REJECTED = "SERIES_BY_IDS_REJECTED";
export const USER_SERIES_GET_PENDING = "USER_SERIES_GET_PENDING";
export const USER_SERIES_GET_FULFILLED = "USER_SERIES_GET_FULFILLED";
export const USER_SERIES_GET_REJECTED = "USER_SERIES_GET_REJECTED";
export const CONTENT_DELETE_EPISODES = "CONTENT_DELETE_EPISODES";
export const CONTENT_REORDER_EPISODES = "CONTENT_REORDER_EPISODES";
export const CONTENT_REORDER_EPISODES_PENDING = "CONTENT_REORDER_EPISODES_PENDING";
export const CONTENT_REORDER_EPISODES_FULFILLED = "CONTENT_REORDER_EPISODES_FULFILLED";
export const CONTENT_REORDER_EPISODES_REJECTED = "CONTENT_REORDER_EPISODES_REJECTED";

export const CHANGE_COMMUNITY_FILTER = "CHANGE_COMMUNITY_FILTER";
export const CHANGE_COMMUNITY_FILTER_CONTENT = "CHANGE_COMMUNITY_FILTER_CONTENT";

//contents
export const CONTENTS = "CONTENTS";
export const CONTENTS_PENDING = "CONTENTS_PENDING";
export const CONTENTS_FULFILLED = "CONTENTS_FULFILLED";
export const CONTENTS_REJECTED = "CONTENTS_REJECTED";
export const SET_CURRENT_CONTENT = "SET_CURRENT_CONTENT";
export const REMOVE_CURRENT_CONTENT = "REMOVE_CURRENT_CONTENT";
export const SET_CURRENT_SERIE = "SET_CURRENT_SERIE";
export const REMOVE_CURRENT_SERIE = "REMOVE_CURRENT_SERIE";
export const CONTENT = "CONTENT";
export const CONTENT_PENDING = "CONTENT_PENDING";
export const CONTENT_FULFILLED = "CONTENT_FULFILLED";
export const CONTENT_REJECTED = "CONTENT_REJECTED";

export const SET_TOP_CONTENT_BY_CATEGORY = "SET_TOP_CONTENT_BY_CATEGORY";

export const REVISION = "REVISION";
export const CONTENT_REVISION_TOP = "CONTENT_REVISION_TOP";
export const REVISION_DELETE = "REVISION_DELETE";
export const DELETE_SERIE = "DELETE_SERIE";

export const CONTENT_RESET = "CONTENT_RESET";
export const CONTENT_CHECK_MEDIA = "CONTENT_CHECK_MEDIA";
export const CONTENT_CHECK_MEDIA_PENDING = "CONTENT_CHECK_MEDIA_PENDING";
export const CONTENT_CHECK_MEDIA_FULFILLED = "CONTENT_CHECK_MEDIA_FULFILLED";
export const CONTENT_CHECK_MEDIA_REJECTED = "CONTENT_CHECK_MEDIA_REJECTED";
export const CONTENT_HASH_RESET = "CONTENT_HASH_RESET";
export const CONTENT_VIDEO_RESET = "CONTENT_VIDEO_RESET";
export const SELECTED_ITEM_RESET = "SELECTED_ITEM_RESET";
export const SET_CONTENT_WEBLINK = "SET_CONTENT_WEBLINK";
export const REMOVE_CONTENT_WEBLINK = "REMOVE_CONTENT_WEBLINK";
export const SET_VIDEO_SUBTITLES = "SET_VIDEO_SUBTITLES";
export const REMOVE_VIDEO_SUBTITLES = "REMOVE_VIDEO_SUBTITLES";

export const CONTENTS_BY_CATEGORY = "CONTENTS_BY_CATEGORY";
export const CONTENTS_BY_CATEGORY_PENDING = "CONTENTS_BY_CATEGORY_PENDING";
export const CONTENTS_BY_CATEGORY_FULFILLED = "CONTENTS_BY_CATEGORY_FULFILLED";
export const CONTENTS_BY_CATEGORY_REJECTED = "CONTENTS_BY_CATEGORY_REJECTED";

export const CONTENTS_BY_IDS = "CONTENTS_BY_IDS";
export const CONTENTS_BY_IDS_PENDING = "CONTENTS_BY_IDS_PENDING";
export const CONTENTS_BY_IDS_FULFILLED = "CONTENTS_BY_IDS_FULFILLED";
export const CONTENTS_BY_IDS_REJECTED = "CONTENTS_BY_IDS_REJECTED";

export const CONTENTS_BY_USER = "CONTENTS_BY_USER";
export const CONTENTS_BY_USER_PENDING = "CONTENTS_BY_USER_PENDING";
export const CONTENTS_BY_USER_FULFILLED = "CONTENTS_BY_USER_FULFILLED";
export const CONTENTS_BY_USER_REJECTED = "CONTENTS_BY_USER_REJECTED";

export const CONTENT_POST = "CONTENT_POST";
export const CONTENT_POST_PENDING = "CONTENT_POST_PENDING";
export const CONTENT_POST_FULFILLED = "CONTENT_POST_FULFILLED";
export const CONTENT_POST_REJECTED = "CONTENT_POST_REJECTED";

export const CONTENT_DELETE = "CONTENT_DELETE";
export const CONTENT_DELETE_PENDING = "CONTENT_DELETE_PENDING";
export const CONTENT_DELETE_FULFILLED = "CONTENT_DELETE_FULFILLED";
export const CONTENT_DELETE_REJECTED = "CONTENT_DELETE_REJECTED";

export const CONTENT_TORRENT_FILE = "CONTENT_TORRENT_FILE";
export const CONTENT_TORRENT_WEB_LINK = "CONTENT_TORRENT_WEB_LINK";
export const TORRENT_NETWORK_TEST_REJECTED = "TORRENT_NETWORK_TEST_REJECTED";
export const CONTENT_HASH = "CONTENT_HASH";
export const CONTENT_VIDEO = "CONTENT_VIDEO";
export const CONTENT_UPLOAD_INFORMATION = "CONTENT_UPLOAD_INFORMATION";
export const CONTENT_SERIE = "CONTENT_SERIE";
export const CONTENT_SERIE_DRAFT = "CONTENT_SERIE_DRAFT";
export const CONTENT_SERIE_DRAFT_RESET = "CONTENT_SERIE_DRAFT_RESET";
export const CONTENT_SERIE_RESET = "CONTENT_SERIE_RESET";

export const CONTENT_OPEN_BUY_MODAL = "CONTENT_OPEN_BUY_MODAL";
export const CONTENT_CLOSE_BUY_MODAL = "CONTENT_CLOSE_BUY_MODAL";

export const CONTENT_PLAY = "CONTENT_PLAY";
export const CONTENT_PAUSE = "CONTENT_PAUSE";
export const CONTENT_PROGRESS_BY_HTTP = "CONTENT_PROGRESS_BY_HTTP";

export const CONTENT_UPDATE = "CONTENT_UPDATE";
export const CONTENT_UPDATE_PENDING = "CONTENT_UPDATE_PENDING";
export const CONTENT_UPDATE_FULFILLED = "CONTENT_UPDATE_FULFILLED";
export const CONTENT_UPDATE_REJECTED = "CONTENT_UPDATE_REJECTED";

export const TOGGLE_ALLOW_EXIT_UPLOAD = "TOGGLE_ALLOW_EXIT_UPLOAD";

export const CONTENT_UPLOAD_SUBTITLE = "CONTENT_UPLOAD_SUBTITLE";
export const CONTENT_UPDATE_GEOBLOCKING = "CONTENT_UPDATE_GEOBLOCKING";
export const CONTENT_UPDATE_GEOBLOCKING_SERIE = "CONTENT_UPDATE_GEOBLOCKING_SERIE";
export const CONTENT_DELETE_GEOBLOCKING = "CONTENT_DELETE_GEOBLOCKING";
export const CONTENT_DELETE_GEOBLOCKING_SERIE = "CONTENT_DELETE_GEOBLOCKING_SERIE";
export const CONTENT_GET_GEOBLOCKING = "CONTENT_GET_GEOBLOCKING";
export const CONTENT_GET_GEOBLOCKING_SERIE = "CONTENT_GET_GEOBLOCKING_SERIE";

//Serie
export const SERIE_POST = "SERIE_POST";
export const SERIE_POST_PENDING = "SERIE_POST_PENDING";
export const SERIE_POST_FULFILLED = "SERIE_POST_FULFILLED";
export const SERIE_POST_REJECTED = "SERIE_POST_REJECTED";

export const SERIE_MEDIA_POST = "SERIE_MEDIA_POST";
export const SERIE_MEDIA_POST_PENDING = "SERIE_MEDIA_POST_PENDING";
export const SERIE_MEDIA_POST_FULFILLED = "SERIE_MEDIA_POST_FULFILLED";
export const SERIE_MEDIA_POST_REJECTED = "SERIE_MEDIA_POST_REJECTED";

export const SERIE_EPISODE_POST = "SERIE_EPISODE_POST";
export const SERIE_EPISODE_POST_PENDING = "SERIE_EPISODE_POST_PENDING";
export const SERIE_EPISODE_POST_FULFILLED = "SERIE_EPISODE_POST_FULFILLED";
export const SERIE_EPISODE_POST_REJECTED = "SERIE_EPISODE_POST_REJECTED";

export const SERIE_SEASON_POST = "SERIE_SEASON_POST";
export const SERIE_SEASON_POST_PENDING = "SERIE_SEASON_POST_PENDING";
export const SERIE_SEASON_POST_FULFILLED = "SERIE_SEASON_POST_FULFILLED";
export const SERIE_SEASON_POST_REJECTED = "SERIE_SEASON_POST_REJECTED";

export const SERIE_PAUSE = "SERIE_PAUSE";
export const SERIE_PAUSE_PENDING = "SERIE_PAUSE_PENDING";
export const SERIE_PAUSE_FULFILLED = "SERIE_PAUSE_FULFILLED";
export const SERIE_PAUSE_REJECTED = "SERIE_PAUSE_REJECTED";

export const SERIE_UPDATE_METADATA = "SERIE_UPDATE_METADATA";
export const SERIE_UPDATE_COVER = "SERIE_UPDATE_COVER";

// carousel
export const CAROUSEL_TO_SLIDER = "CAROUSEL_TO_SLIDER";
export const CAROUSEL_TO_SLIDER_RESET = "CAROUSEL_TO_SLIDER_RESET";

export const TOGGLE_MAIN_PLAYER = "TOGGLE_MAIN_PLAYER";
export const MAIN_PLAYER = "MAIN_PLAYER";
export const MAIN_PLAYER_VIDEO_UUID = "MAIN_PLAYER_VIDEO_UUID";
export const MAIN_PLAYER_CONTENTTYPE = "MAIN_PLAYER_CONTENTTYPE";
export const MAIN_PLAYER_VIDEO_SUB = "MAIN_PLAYER_VIDEO_SUB";
export const MAIN_PLAYER_HASH = "MAIN_PLAYER_HASH";

//ads
export const AD_GET = "AD_GET";
export const AD_GET_PENDING = "AD_GET_PENDING";
export const AD_GET_FULFILLED = "AD_GET_FULFILLED";
export const AD_GET_REJECTED = "AD_GET_REJECTED";

export const AD_POST = "AD_POST";
export const AD_POST_PENDING = "AD_POST_PENDING";
export const AD_POST_FULFILLED = "AD_POST_FULFILLED";
export const AD_POST_REJECTED = "AD_POST_REJECTED";

export const AD_POST_TYPE = "AD_POST_TYPE";

export const AD_REWARD = "AD_REWARD";
export const AD_REWARD_PENDING = "AD_REWARD_PENDING";
export const AD_REWARD_FULFILLED = "AD_REWARD_FULFILLED";
export const AD_REWARD_REJECTED = "AD_REWARD_REJECTED";

export const AD_TOGGLE = "AD_TOGGLE";

export const AD_RESET = "AD_RESET";
export const SHOW_AD_BLOCKER_MODAL = "SHOW_AD_BLOCKER_MODAL";
export const HAS_AD_BLOCKER = "HAS_AD_BLOCKER";

//torrent
export const TORRENT_PUSH = "TORRENT_PUSH";
export const TORRENT_REMOVE = "TORRENT_REMOVE";
export const TORRENT_CLIENT = "TORRENT_CLIENT";
export const TORRENT_PORT = "TORRENT_PORT";
export const TORRENT_NETWORK_TEST = "TORRENT_NETWORK_TEST";
export const TORRENT_UPDATE = "TORRENT_UPDATE";

//media
export const MEDIA_POST = "MEDIA_POST";
export const MEDIA_POST_PENDING = "MEDIA_POST_PENDING";
export const MEDIA_POST_FULFILLED = "MEDIA_POST_FULFILLED";
export const MEDIA_POST_REJECTED = "MEDIA_POST_REJECTED";

//payment
export const PAYMENT_CONTENT_POST = "PAYMENT_CONTENT_POST";
export const PAYMENT_CONTENT_POST_PENDING = "PAYMENT_CONTENT_POST_PENDING";
export const PAYMENT_CONTENT_POST_FULFILLED = "PAYMENT_CONTENT_POST_FULFILLED";
export const PAYMENT_CONTENT_POST_REJECTED = "PAYMENT_CONTENT_POST_REJECTED";
export const PAYMENT_CONTENT_BOOST = "PAYMENT_CONTENT_BOOST";
export const PAYMENT_CONTENT_BOOST_PENDING = "PAYMENT_CONTENT_BOOST_PENDING";
export const PAYMENT_CONTENT_BOOST_FULFILLED = "PAYMENT_CONTENT_BOOST_FULFILLED";
export const PAYMENT_CONTENT_BOOST_REJECTED = "PAYMENT_CONTENT_BOOST_REJECTED";
export const PAYMENT_APPLY_TICKET = "PAYMENT_APPLY_TICKET";
export const PAYMENT_APPLY_TICKET_PENDING = "PAYMENT_APPLY_TICKET_PENDING";
export const PAYMENT_APPLY_TICKET_FULFILED = "PAYMENT_APPLY_TICKET_FULFILED";
export const PAYMENT_APPLY_TICKET_REJECTED = "PAYMENT_APPLY_TICKET_REJECTED";
export const CLEAR_PAYMENT_BOOST_ERROR = "CLEAR_PAYMENT_BOOST_ERROR";

//search
export const SEARCH = "SEARCH";
export const SEARCH_TEXT = "SEARCH_TEXT";
export const SEARCH_FILTER = "SEARCH_FILTER";
export const SEARCH_KEY = "SEARCH_KEY";
export const SEARCH_PAGE = "SEARCH_PAGE";
export const SEARCH_VALUE = "SEARCH_VALUE";
export const SEARCH_SHOW = "SEARCH_SHOW";
export const SEARCH_HIDE = "SEARCH_HIDE";
export const SEARCH_PENDING = "SEARCH_PENDING";
export const SEARCH_FULFILLED = "SEARCH_FULFILLED";
export const SEARCH_REJECTED = "SEARCH_REJECTED";
export const SEARCH_MOOD = "SEARCH_MOOD";
export const SEARCH_MOOD_PENDING = "SEARCH_MOOD_PENDING";
export const SEARCH_MOOD_FULFILLED = "SEARCH_MOOD_FULFILLED";
export const SEARCH_MOOD_REJECTED = "SEARCH_MOOD_REJECTED";

//follow
export const FOLLOW = "FOLLOW";
export const FOLLOW_PENDING = "FOLLOW_PENDING";
export const FOLLOW_FULFILLED = "FOLLOW_FULFILLED";
export const FOLLOW_REJECTED = "FOLLOW_REJECTED";
export const UNFOLLOW = "UNFOLLOW";
export const UNFOLLOW_PENDING = "UNFOLLOW_PENDING";
export const UNFOLLOW_FULFILLED = "UNFOLLOW_FULFILLED";
export const UNFOLLOW_REJECTED = "UNFOLLOW_REJECTED";
export const FOLLOWERS = "FOLLOWERS";
export const FOLLOWERS_PENDING = "FOLLOWERS_PENDING";
export const FOLLOWERS_FULFILLED = "FOLLOWERS_FULFILLED";
export const FOLLOWERS_REJECTED = "FOLLOWERS_REJECTED";
export const FOLLOWEDS = "FOLLOWEDS";
export const FOLLOWEDS_PENDING = "FOLLOWEDS_PENDING";
export const FOLLOWEDS_FULFILLED = "FOLLOWEDS_FULFILLED";
export const FOLLOWEDS_REJECTED = "FOLLOWED_REJECTED";
export const CLEAR_UNFOLLOW_ERROR = "CLEAR_UNFOLLOW_ERROR";
export const CLEAR_FOLLOW_ERROR = "CLEAR_FOLLOW_ERROR";

//mailing
export const MAIL_CASH_OUT = "MAIL_CASH_OUT";
export const MAIL_CASH_OUT_REJECTED = "MAIL_CASH_OUT_REJECTED";
export const MAIL_BUY_TOKENS = "MAIL_BUY_TOKENS";
export const MAIL_BUY_TOKENS_REJECTED = "MAIL_BUY_TOKENS_REJECTED";
export const MAIL_CLEAR_ERROR = "MAIL_cLEAR_ERROR";

// versioning
export const APP_INFO = "APP_INFO";
export const APP_INFO_REJECTED = "APP_INFO_REJECTED";
export const APP_INFO_FULFILLED = "APP_INFO_FULFILLED";
export const APP_INFO_PENDING = "APP_INFO_PENDING";

//AWS
export const AWS_ACCESS_KEY = "AWS_ACCESS_KEY";
export const AWS_BUCKET = "AWS_BUCKET";

// stats
export const CREATOR_STATS = "CREATOR_STATS";
export const SEEDER_STATS = "SEEDER_STATS";
export const CREATOR_STATS_ENGAGEMENT = "CREATOR_STATS_ENGAGEMENT";

// Google Analytics
export const GA_PUSH = "GA_PUSH";
export const GA_PUSH_FIRST = "GA_PUSH_FIRST";
export const GA_SHIFT = "GA_SHIFT";

export const UPDATE_LOCAL_PURCHASED = "UPDATE_LOCAL_PURCHASED";

//CARRUSELS
export const GET_CARRUSELS_LIST = "GET_CARRUSELS_LIST";
export const GET_SINGLE_CARRUSEL = "GET_SINGLE_CARRUSEL";
export const GET_CARRUSELS_CONTENT = "GET_CARRUSELS_CONTENT";
export const GET_CARRUSELS_SERIES = "GET_CARRUSELS_SERIES";
export const SET_CARRUSELS_WITH_CONTENT = "SET_CARRUSELS_WITH_CONTENT";
export const GET_CARRUSELS_BY_ID = "GET_CARRUSELS_BY_ID";

//PLAYER
export const SET_PLAYER_DURATION = "SET_PLAYER_DURATION";
export const SET_PLAYER_PROGRESS = "SET_PLAYER_PROGRESS";
export const SET_PREV_PLAYER_PROGRESS = "SET_PLAYER_PROGRESS";
export const SET_PLAYER_END = "SET_PLAYER_END";
export const SET_PLAYER_START = "SER_PLAYER_END";
export const SET_BUFFER_END = "SET_BUFFER_END";
export const SET_BUFFER_START = "SET_BUFFER_START";
//NEXT EPISODE
export const SHOW_NEXT_EPISODE = "SHOW_NEXT_EPISODE";
export const DISMISS_NEXT_EPISODE = "DISMISS_NEXT_EPISODE"; //Cuando pasan los 10s
export const OMIT_NEXT_EPISODE = "OMIT_NEXT_EPISODE"; //Si clickeo omitir
export const RESET_NEXT_EPISODE_VALUE = "RESET_NEXT_EPISODE_VALUE"; //Si clickeo omitir
//LANDING
export const SET_CARROUSEL_FOR_LANDING = "SET_CARROUSEL_FOR_LANDING";
export const REMOVE_CARROUSEL_FOR_LANDING = "REMOVE_CARROUSEL_FOR_LANDING";

//AUTH
export const AUTH_CHECK = "AUTH_CHECK";
export const AUTH_CHECK_PENDING = "AUTH_CHECK_PENDING";
export const AUTH_CHECK_FULFILLED = "AUTH_CHECK_FULFILLED";
export const AUTH_CHECK_REJECTED = "AUTH_CHECK_REJECTED";

//SUGGESTIONS
export const GET_SUGGESTIONS_LIST = "GET_SUGGESTIONS_LIST";
export const SET_SUGGESTIONS_LIST = "SET_SUGGESTIONS_LIST";

// LANGS
export const GET_LANGS = "GET_LANGS";

// LANDING SCREEN
export const SET_SCREEN = "SET_SCREEN";

// SIDENAV
export const TOGGLE_SIDENAV = "TOGGLE_SIDENAV";

// MODAL
export const OPEN_MODAL = "OPEN_MODAL";
export const CLOSE_MODAL = "CLOSE_MODAL";

// LOADER LANDING
export const LOADING_LANDING = "LOADING_LANDING";

// WRITE CONTENT TO LOAD
export const WRITE_CONTENT_TO_LOAD = "WRITE_CONTENT_TO_LOAD";

// GET_FLIXX_INFO
export const GET_FLIXX_INFO = "GET_FLIXX_INFO";
export const GET_FLIXX_INFO_REJECTED = "GET_FLIXX_INFO_REJECTED";
export const GET_FLIXX_INFO_FULFILLED = "GET_FLIXX_INFO_FULFILLED";
export const GET_FLIXX_INFO_PENDING = "GET_FLIXX_INFO_PENDING";

// CONTENT TO UPLOAD
export const UPLOAD_CONTENT_META = "UPLOAD_CONTENT_META";
export const UPLOAD_CONTENT_CATEGORY = "UPLOAD_CONTENT_CATEGORY";
export const UPLOAD_CONTENT_TAGS = "UPLOAD_CONTENT_TAGS";
export const UPLOAD_CONTENT_RATING = "UPLOAD_CONTENT_RATING";
export const UPLOAD_CONTENT_CLEAR = "UPLOAD_CONTENT_CLEAR";
export const UPLOAD_CONTENT_COVER = "UPLOAD_CONTENT_COVER";
export const UPLOAD_CONTENT_SUBTITLE = "UPLOAD_CONTENT_SUBTITLE";
export const UPLOAD_CONTENT_AUDIO_LANG = "UPLOAD_CONTENT_AUDIO_LANG";
export const UPLOAD_CONTENT_PRICE = "UPLOAD_CONTENT_PRICE";
export const UPLOAD_CONTENT_DISTRIBUTION = "UPLOAD_CONTENT_DISTRIBUTION";

// GET CONTENT ULOAD UUID
export const GET_CONTENT_UPLOAD_UUID = "GET_CONTENT_UPLOAD_UUID";
export const UPLOAD_CONTENT_COVER_POST = "UPLOAD_CONTENT_COVER_POST";
export const UPLOAD_CONTENT_DETAILS_POST = "UPLOAD_CONTENT_DETAILS_POST";
export const UPLOAD_CONTENT_SUBTITLES_POST = "UPLOAD_CONTENT_SUBTITLES_POST";
export const RESET_UPLOAD_CONTENT = "RESET_UPLOAD_CONTENT";

// GET_DRM_TOKEN
export const GET_DRM_TOKEN = "GET_DRM_TOKEN";
export const GET_DRM_TOKEN_REJECTED = "GET_DRM_TOKEN_REJECTED";
export const GET_DRM_TOKEN_FULFILLED = "GET_DRM_TOKEN_FULFILLED";
export const GET_DRM_TOKEN_PENDING = "GET_DRM_TOKEN_PENDING";

// GET_MANIFEST
export const GET_MANIFEST = "GET_MANIFEST";
export const GET_MANIFEST_REJECTED = "GET_MANIFEST_REJECTED";
export const GET_MANIFEST_FULFILLED = "GET_MANIFEST_FULFILLED";
export const GET_MANIFEST_PENDING = "GET_MANIFEST_PENDING";

// EDIT CONTENT
export const SET_CONTENT_TO_EDIT = "SET_CONTENT_TO_EDIT";
export const SET_CONTENT_EDITED = "SET_CONTENT_EDITED";
export const DELETE_MEDIA_ID = "DELETE_MEDIA_ID";
export const DELETE_SUBTITLE_ID = "DELETE_SUBTITLE_ID";

// UPLOAD CONTENT CURRENT STEP
export const SET_CURRENT_STEP = "SET_CURRENT_STEP";

// GET USER STATS
export const GET_STATS = "GET_STATS";
export const GET_STATS_FULFILLED = "GET_STATS_FULFILLED";
export const GET_STATS_PENDING = "GET_STATS_PENDING";
export const GET_STATS_REJECTED = "GET_STATS_REJECTED";

// CONTENT_TO_SHOW
export const SET_CONTENT_TO_SHOW = "SET_CONTENT_TO_SHOW";